import deepExtend from 'deep-extend'

/**
 * [Store Name]
 *
 * @related [app/Models/Tenant/MyModel.php]
 */

const apiModels = typeof window.FrontendApi !== 'undefined' ? _.cloneDeep(window.FrontendApi.models) : {}

// $store2.$vuex.getters['Api/test']
const state = {
  // Testing
  test: 'Hello...???',

  ////////////////////////////
  // $store2
  ////////////////////////////

  models: _.cloneDeep(apiModels)
  // models: $store2.data.models
  // models: { Application: { id: '', customer_id: '001', status: 0 } }
}

const getters = {
  // Testing
  test: (state) => state.test,

  ////////////////////////////
  // $store2
  ////////////////////////////

  models: (state) => state.models,
  // models: (state) => 'testing...',
}

// Mutations should NEVER be ASYNC
const mutations = {
  // Testing
  reset: (state, value) => {
    state.test = 'Hello!!!.....'
  },
  setTest: (state, value) => {
    state.test = value
  },

  ////////////////////////////
  // $store2
  ////////////////////////////

  setModel: (state, { model, value }) => {
    // return state.models = { Application: { id: Math.random() } }

    // If value is null, load an empty model
    if (value === null || !value || value.length === 0) {
      const schema = _.cloneDeep(apiModels[model])
      return _.set(state.models, model, schema)
    }

    // Multiple models collection
    if (Array.isArray(value)) {
      return _.set(state.models, model, value)
    }

    // Single model
    deepExtend(state.models[model], value)
  }
}

// Actions can be ASYNC
const actions = {
  // Testing
  reset: (context, value) => {
    context.commit('reset', value)
  },
  setTest: (context, value) => {
    // console.warn('Api/setTest', { context, value })
    context.commit('setTest', value)
  },

  ////////////////////////////
  // $store2
  ////////////////////////////

  setModel(context, data) {
    if (!data) return console.error('$store2.$vuex: setModel() expects at least 1 argument')
    if (!data.model) return console.error('$store2.$vuex: Missing { model } argument')
    // if (!data.value) return console.error('$store2.$vuex: Missing { value } argument')

    // Check if keys match model
    // ...

    // Save new data
    context.commit('setModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
